<section class="expense-list-page">
  <div class="col-sm-12 main-content">
    <div class="clearfix container-box">
      <div class="col-sm-12 attr-container">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <input
                matInput
                placeholder="Spouse"
                name="wife"
                [disabled]="1 | isReadonlyRole"
                [(ngModel)]="guestItem.wife"
                type="text"
                (blur)="onBlur()"
                (focus)="onFocus()"
              />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <input
                matInput
                placeholder="Kids Names"
                name="kids"
                [disabled]="1 | isReadonlyRole"
                [(ngModel)]="guestItem.kids"
                type="text"
                (blur)="onBlur()"
                (focus)="onFocus()"
              />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <input
                matInput
                placeholder="Drink Preference"
                name="drink"
                [disabled]="1 | isReadonlyRole"
                [(ngModel)]="guestItem.drink"
                type="text"
                (blur)="onBlur()"
                (focus)="onFocus()"
              />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <input
                matInput
                placeholder="Hobby"
                name="hobby"
                [disabled]="1 | isReadonlyRole"
                [(ngModel)]="guestItem.hobby"
                type="text"
                (blur)="onBlur()"
                (focus)="onFocus()"
              />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <input
                matInput
                placeholder="Favorite Sport"
                name="sport"
                [disabled]="1 | isReadonlyRole"
                [(ngModel)]="guestItem.sport"
                type="text"
                (blur)="onBlur()"
                (focus)="onFocus()"
              />
            </mat-form-field>
          </div>

          <div class="col-md-3" *ngFor="let item of itemKeys">
            <mat-form-field class="mat-block">
              <input
                matInput
                placeholder="{{ item.caption }}"
                [disabled]="1 | isReadonlyRole"
                [(ngModel)]="attributes[item.key]"
                type="text"
                (blur)="onBlur()"
                (focus)="onFocus()"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
